import { ETelemetryMessageType } from '../enums/ETelemetryPacketType'
import { ITelemetryPacket } from '../interfaces/ITelemetryPacket'
import { hexToDecimal } from './hexToDecimal'
import { stringToBytes } from './stringToBytes'
import { xorBytes } from './xorBytes'

// TODO: with now having all readable characters, we might not need the whole stringToBytes() except the checksum
export function parseTelemetryPacket(telemetryPackage: string): Omit<ITelemetryPacket, 'id'> & { valid: boolean } {
    const packageInBytes = stringToBytes(telemetryPackage)
    // the type is one character, it can be anything, like `1` or a `L`
    // const type = String.fromCharCode(packageInBytes[0]) as ETelemetryMessageType
    const type = packageInBytes[0] as ETelemetryMessageType
    const timestamp = String.fromCharCode(
        packageInBytes[1],
        packageInBytes[2],
        packageInBytes[3],
        packageInBytes[4],
        packageInBytes[5],
        packageInBytes[6],
        packageInBytes[7],
        packageInBytes[8],
    )
    const packageId = String.fromCharCode(packageInBytes[9], packageInBytes[10], packageInBytes[11], packageInBytes[12])
    const length = hexToDecimal(String.fromCharCode(packageInBytes[13], packageInBytes[14]))

    const messageBytes = []
    // The length is not trustworthy or not sure how its being counted. so lets just grab everything except the last 3 bytes
    // for (let index = 15; index < (15 + parseInt(length)); index++) {
    for (let index = 15; index < packageInBytes.length - 3; index++) {
        messageBytes.push(packageInBytes[index])
    }
    const message = String.fromCharCode(...messageBytes)

    const checksum = String.fromCharCode(...packageInBytes.slice(-3, -1))
    const packetBytesWithoutChecksum = [...packageInBytes.slice(0, -3)]
    const packetXOR = xorBytes(packetBytesWithoutChecksum)

    return {
        type,
        timestamp,
        packageId,
        length,
        checksum,
        valid: packetXOR.toString(16) === checksum,
        message,
    }
}
